import { config } from './config';
import axios from "axios";

export const saulFacebookAdsService = {
    get,
    config
};

function get(params){

    let axiosConfig = {},
        endpoint;

    // Append to request.
    axiosConfig['params'] = params;

    endpoint = '/api/proxy/saul/facebook-app/ads/';

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}${endpoint}`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}
